import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';

import { PATH_TOLL_FREE } from '~/common/utils/consts.js';

// Import Stylesheet
import styles from './random-toll-free-link.css';

@withRouter
export default class RandomTollFreeLink extends Component {
    render() {
        return (
            <div className={styles.wrapper}>
                <Link
                    id="custom-toll-free__random-link"
                    to={PATH_TOLL_FREE}
                >
                    Get a randomly generated toll free number &#187;
                </Link>
            </div>
        );
    }
}
